<template>
  <div class="body-container import-outside-order">
    <div class="row">
      <span class="label">投保人</span>
      <input type="text" placeholder="请输入投保人姓名" v-model="formData.holderName" maxlength="20">
    </div>
    <div class="row">
      <span class="label">为谁投保</span>
      <div class="text" @click="openRelationPopup">
        <span class="label" v-if="formData.familyMember">{{formData.familyMember}}</span>
        <span v-else>请选择家庭关系</span>
        <i class="icon-xiangyou"></i>
      </div>
    </div>
    <div class="row" v-if="formData.familyMember != '本人'">
      <span class="label">被保人</span>
      <input type="text" placeholder="请输入被保人姓名" v-model="formData.insuranceName" maxlength="20">
    </div>
    <div class="row">
      <span class="label">被保人身份证号</span>
      <input type="text" placeholder="请输入被保人身份证号" v-model="formData.insuranceIdCard" maxlength="30">
    </div>
    <div class="row">
      <span class="label">保险公司</span>
      <div class="text" @click="openCompanyPopup">
        <span class="label" v-if="formData.companyName">{{formData.companyName}}</span>
        <span v-else>请选择保险公司（选填）</span>
        <i class="icon-xiangyou"></i>
      </div>
    </div>
    <div class="row">
      <span class="label">产品名称</span>
      <input type="text" placeholder="请输入产品名称" v-model="formData.productName" maxlength="30">
    </div>
    <div class="row">
      <span class="label">保险单号</span>
      <input type="text" placeholder="请输入保险单号" v-model="formData.policyNo" maxlength="30">
    </div>
    <div class="row">
      <span class="label">保险生效日</span>
      <div class="text" @click="dateShow=true">
        <span class="label" v-if="formData.startTime">{{formData.startTime}}</span>
        <span v-else>请选择保险生效日</span>
        <i class="icon-xiangyou"></i>
      </div>
    </div>
    <div class="row">
      <span class="label">保险期限</span>
      <div class="text" @click="openGuarateePopup">
        <span class="label" v-if="formData.guarateeText">{{formData.guarateeText}}</span>
        <span v-else>请选择保险期限</span>
        <i class="icon-xiangyou"></i>
      </div>
    </div>
    <div class="row">
      <span class="label">保费</span>
      <input type="number" placeholder="请输入保费" maxlength="9" v-model="formData.fee">
    </div>
    <div class="row">
      <span class="label">保额</span>
      <input type="number" placeholder="请输入保额" maxlength="9" v-model="formData.totalInsured">
    </div>
    <div class="bottom-box">
      <van-button class="btn" type="info" @click="save">保存</van-button>
    </div>

    <!-- 家庭关系弹窗 -->
    <van-popup v-model="relationShow" position="bottom">
      <van-picker
        title="请选择家庭关系"
        show-toolbar
        ref="relation"
        :columns="columns"
        @confirm="relationSubmit"
        @cancel="relationShow=false"
      />
    </van-popup>

    <!-- 保司 -->
    <van-popup v-model="companyShow" position="bottom">
      <van-picker
        title="请选择家庭关系"
        show-toolbar
        ref="company"
        :columns="companyList"
        @confirm="companySubmit"
        @cancel="companyShow=false"
      />
    </van-popup>

    <!-- 保障期限弹窗 -->
    <van-popup v-model="guarateeShow" position="bottom">
      <van-picker
        title="请选择保障期限"
        show-toolbar
        ref="guaratee"
        :columns="guarateeList"
        @confirm="guarateeSubmit"
        @cancel="guarateeShow=false"
      />
    </van-popup>

    <van-popup v-model="dateShow" position="bottom">
      <van-datetime-picker
        v-model="date"
        type="date"
        title="请选择保险生效日"
        :max-date="maxDate"
        @cancel="dateShow=false"
        @confirm="dateShow=false;$set(formData,'startTime',$tools.dateFormat(date))"
      />
    </van-popup>


  </div>
</template>
<script>
//当前实例组件
export default {
  data: () => ({
    id:"",
    formData:{},
    columns:["本人","配偶","父母","子女"],//家庭关系
    relationShow:false,//家庭关系弹窗
    companyList:[],//保司
    companyMap:[],//保司原始数据
    companyShow:false,//保司弹窗
    guarateeShow:false,//保障期限弹窗
    guarateeList:[
      {
        text: '保障多少年',
        children: [{'text':'1年'},{'text':'5年'},{'text':'10年'},{'text':'15年'},{'text':'20年'},{'text':'25年'},{'text':'30年'},{'text':'35年'},{'text':'40年'},{'text':'45年'},{'text':'50年'},{'text':'55年'},{'text':'60年'},{'text':'65年'},{'text':'70年'}],
      },
      {
        text: '保至多少岁',
        children: [{'text':'50岁'},{'text':'55岁'},{'text':'60岁'},{'text':'65岁'},{'text':'70岁'},{'text':'75岁'},{'text':'80岁'},{'text':'85岁'},{'text':'90岁'},{'text':'99岁'}],
      },
      {
        text: '终身',
        children: [{'text':'终身'}],
      },
    ],
    date:new Date(),
    maxDate:new Date(new Date().getTime()+24*60*60*1000),
    dateShow:false,
  }),
  mounted() {
    this.getData();
    this.getCompany();
  },
  methods: {
    getData(){
      if(this.$route.query.id){
        this.id = this.$route.query.id;
        this.$http({
          type: "PUT",
          url: `/api/queryEnteryPolicyDetail/bplat/${this.id}`,
          data: {
            // id: this.id
          }
        }).then(res=>{
          // setColumnValue
          const data = res.data;
          if(data.startTime) {
            data.startTime = data.startTime.substr(0,10);
            this.date = new Date(data.startTime);
          }
          if(data.guarateeType==1){
            data.guarateeText = "终身";
          }else if(data.guarateeType==2){
            data.guarateeText = data.guarateeLimit+"岁";
          }else if(data.guarateeType==3){
            data.guarateeText = data.guarateeLimit+"年";
          }

          this.formData = data;
        })
      }
    },
    // 验证被保人信息
    yzInsurance(formData){
      return this.$http({
        type: "POST",
        url: "/api/bplat/check2metaIDAndName",
        data: {
          name:formData.insuranceName,
          idcard:formData.insuranceIdCard,
          cardType:1
        }
      })
    },
    yz(formData){
      if(!formData.holderName){
        this.$notice.msg("请输入投保人姓名");
        return false;
      }
      if(!formData.familyMember){
        this.$notice.msg("请选择家庭关系");
        return false;
      }
      if(!formData.insuranceName){
        this.$notice.msg("请输入被保人姓名");
        return false;
      }
      if(!formData.insuranceIdCard) {
        this.$notice.msg("请输入被保人身份证号");
        return false;
      }
      if(!this.$regulars.issfz(this.formData.insuranceIdCard)) {
        this.$notice.msg("请输入正确的被保人身份证号");
        return false;
      }
      if(!formData.productName){
        this.$notice.msg("请输入产品名称");
        return false;
      }
      if(!formData.policyNo){
        this.$notice.msg("请输入保险单号");
        return false;
      }
      if(!formData.startTime){
        this.$notice.msg("请选择保险生效日");
        return false;
      }
      if(!formData.guarateeText) {
        this.$notice.msg("请输入保险期限");
        return false;
      }
      if(!formData.fee && formData.fee !== 0) {
        this.$notice.msg("请输入保费");
        return false;
      }
      if(isNaN(formData.fee)||formData.fee<0) {
        this.$notice.msg("保费只能为非负数字");
        return false;
      }
      if(formData.fee>999999999){
        this.$notice.msg("保费超限制");
        return false;
      }
      if(!formData.totalInsured && formData.totalInsured !== 0) {
        this.$notice.msg("请输入保额");
        return false;
      }
      if(isNaN(formData.totalInsured)||formData.totalInsured<=0) {
        this.$notice.msg("保额只能为正数字");
        return false;
      }
      if(formData.totalInsured>999999999){
        this.$notice.msg("保额超限制");
        return false;
      }
      return true;
    },
    async save(){
      const formData = Object.assign({},this.formData)
      if(formData.familyMember == "本人"){
        formData.insuranceName = this.formData.holderName;
      }
      if(!this.yz(formData)){
        return;
      }
      formData.fee = formData.fee*1;
      formData.totalInsured = formData.totalInsured*1;
      const data = await this.yzInsurance(formData);
      if(data.httpCode != 1){
        return;
      }
      this.$http({
        type: "PUT",
        url: this.id?"/api/bplat/editPolicyDetail":"/api/bplat/entryPolicy",
        data: formData
      }).then(res=>{
        this.$notice.msg("保存成功");
        history.back()
      })
    },
    // 打开保障期限
    openGuarateePopup(){
      this.guarateeShow = true;
      if(this.formData.guarateeText) {
        window.setTimeout(()=>{
          const text = this.formData.guarateeText;
          if(text.includes("年")){
            this.$refs.guaratee.setColumnValue(0,"保障多少年");
            this.$refs.guaratee.setColumnValue(1,this.formData.guarateeText);
          }else if(text.includes("岁")){
            this.$refs.guaratee.setColumnValue(0,"保至多少岁");
            this.$refs.guaratee.setColumnValue(1,this.formData.guarateeText);
          }else{
            this.$refs.guaratee.setColumnValue(0,"终身");
          }
        },1)
      }

    },
    // 保障期限选择
    guarateeSubmit(data,e){
      console.log(data,e)
      this.guarateeShow = false;
      this.$set(this.formData,"guarateeText", data[1]);
      if(data[0] == "保障多少年"){
        this.$set(this.formData,"guarateeType", 3);
        this.$set(this.formData,"guarateeLimit",data[1].replace("年",""));
      }else if(data[0] == "保至多少岁"){
        this.$set(this.formData,"guarateeType", 2);
        this.$set(this.formData,"guarateeLimit",data[1].replace("岁",""));
      }else if(data[0] == "终身"){
        this.$set(this.formData,"guarateeType", 1);
        this.$set(this.formData,"guarateeLimit","");
      }
    },

    // 打开家庭关系弹窗
    openRelationPopup(){
      this.relationShow = true;
      if(this.formData.familyMember) {
        window.setTimeout(()=>{
          this.$refs.relation.setColumnValue(0,this.formData.familyMember)
        },1)
      }
    },
    // 家庭关系选择
    relationSubmit(data){
      this.$set(this.formData,"familyMember",data);
      this.relationShow = false;
    },
    // 打开保司弹窗
    openCompanyPopup(){
      this.companyShow = true;
      if(this.formData.companyName) {
        window.setTimeout(()=>{
          this.$refs.company.setColumnValue(0,this.formData.companyName)
        },1)
      }
    },
    //保司选择
    companySubmit(data){
      this.companyShow = false;
      const company = this.companyMap.find((item)=>{
        return item.name==data;
      });
      this.$set(this.formData,"companyName",company.name);
      this.$set(this.formData,"companyId",company.id);
    },
    //保司列表
    getCompany(){
      this.$http({
        type: "PUT",
        url: "/api/bplat/queryCompanyList",
        data: {}
      }).then(res=>{
        this.companyList = res.data.map((item)=>{
          return item.name
        });
        this.companyMap = res.data;
      })
    },
  },
};
</script>
<style lang="scss" scoped>
@import "./importOutsideOrder.scss";
</style>
